// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  Dialog,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/lucideIcons/x.svg';
import PropTypes from 'prop-types';
import DialogTransition from '../Transition/DialogTransition';
import { NOOP } from '../../../const/CommonConst';

const ConfirmModal = ({
  open = false,
  handleClose = NOOP,
  confirm = NOOP,
  cancel = () => {
    handleClose();
  },
  alertLabelText = '',
  content = null,
  confirmButtonLabel = 'Yes',
  cancelButtonLabel = 'No',
  resourceName = '',
  hideConfirmButton = false,
  maxWidth = 'xs',
}) => {
  const onClose = useCallback(
    (e) => {
      e?.stopPropagation();
      handleClose();
    },
    [handleClose]
  );

  return (
    <Box>
      <Dialog
        maxWidth={maxWidth}
        open={open}
        onClose={onClose}
        slots={{
          transition: DialogTransition,
        }}
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            {resourceName || ''}
          </Box>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          title="Close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container>
            <Grid
              size={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 3,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mt: 1,
                }}
              >
                {content || (
                  <Typography variant="body1" align="center">
                    {alertLabelText}
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
            }}
          >
            {!hideConfirmButton && (
              <Button
                onClick={confirm}
                variant="outlined"
                title={confirmButtonLabel}
                size="small"
              >
                {confirmButtonLabel}
              </Button>
            )}
            <Button
              variant="contained"
              title={cancelButtonLabel}
              onClick={cancel || handleClose}
              size="small"
            >
              {cancelButtonLabel}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func,
  alertLabelText: PropTypes.string,
  content: PropTypes.node,
  cancelButtonLabel: PropTypes.string.isRequired,
  confirmButtonLabel: PropTypes.string.isRequired,
  resourceName: PropTypes.string.isRequired,
  hideConfirmButton: PropTypes.bool.isRequired,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

export default ConfirmModal;
